import React, { useEffect, useState } from 'react';

type IInput<T, R> = [T, (event: React.ChangeEvent<R>) => void, (F) => void];

const useInputBase = <T, R>(
  initialValue: T,
  parse: (v: string) => T,
): IInput<T, R> => {
  const [value, setValue] = useState<T>(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const onChange = (event) => {
    const v = parse(event.currentTarget.value);

    setValue(v);
  };

  return [value, onChange, setValue];
};

export const useNumericInput = <R>(
  initialValue: number,
  parser = Number,
): IInput<number, R> => useInputBase(initialValue, parser);

export const useInput = <R>(
  initialValue: string,
  parser = String,
): IInput<string, R> => useInputBase<string, R>(initialValue, parser);
